<script>
  import Balance from "@distributor/svelte/Payments/Balance.svelte";
  import Breadcrumb from "@shared/svelte/Components/Breadcrumb.svelte";
  import Payments from "@distributor/svelte/Payments/Page.svelte";
  import SettlementReport from "@distributor/svelte/Payments/SettlementReport.svelte";
</script>

<Breadcrumb heading="Payments" rightComponent={SettlementReport} rightIcon={Balance} />

<Payments />
